import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { AttendanceContractTypeService } from '../../services/attendance-contract-type/attendance-contract-type.service';
import { AttendanceContractType } from '../../models/attendance-contract-type.model';
import { AttendanceContractTypeActions } from './attendance-contract-type.actions';

export class AttendanceContractTypeStateModel {
  public attendanceTypes: AttendanceContractType[];
}

const defaults = {
  attendanceTypes: [],
};

@State<AttendanceContractTypeStateModel>({
  name: 'attendanceContractType',
  defaults,
})
@Injectable()
export class AttendanceContractTypeState {
  constructor(
    private attendanceContractTypeService: AttendanceContractTypeService
  ) {}

  @Action(AttendanceContractTypeActions.GetAttendanceContractType)
  getAttendanceType({
    getState,
    setState,
  }: StateContext<AttendanceContractTypeStateModel>) {
    let attendanceTypes =
      this.attendanceContractTypeService.getAttendanceContractTypes();
    const state = getState();
    setState({ ...state, attendanceTypes });
  }
}
